// extracted by mini-css-extract-plugin
export default {"container":"ContactActions_container__6mnyM","description":"ContactActions_description__p-R3j","notes":"ContactActions_notes__QPHe8","noActions":"ContactActions_noActions__kPOOr"};